<template>
  <container>
    <checkout-progress reservation />

    <modal
      v-if="!approved || !ticketsAvailable"
      no-close
      center-content
    >
      <loader-spinner :size="1.5" />
      <template #footer>
        <span v-html="$t('loading')" />
      </template>
    </modal>

    <header
      v-if="approved && ticketsAvailable"
      class="cart__header"
    >
      <headline>{{ $t('title') }}</headline>
      <p>{{ $t('reservationProcessed') }}</p>
    </header>
  </container>
</template>

<script>
import checkoutProgress from '../components/checkoutProgress.vue'
import container from '../components/container.vue'
import headline from '../components/headline.vue'
import loaderSpinner from '../components/loaderSpinner.vue'
import modal from '../components/modal.vue'

import api from '../api.js'
import eventBus from '../eventBus.js'

export default {
  name: 'VReservationProcess',

  components: {
    checkoutProgress,
    container,
    headline,
    loaderSpinner,
    modal
  },

  data () {
    return {
      approved: false,
      ticketsAvailable: false,
      barcodes: {}
    }
  },

  mounted () {
    this.pollStatus()
    this.$tracking.track(this.$route.path, 'r-be')
  },

  methods: {
    pollStatus () {
      api.get('checkout/' + this.$store.state.orderReference + '/status/').then(response => {
        if (response.data.status === 'approved') {
          this.polling = null
          this.approved = true
          this.processCheckout()
        } else if (response.data.status === 'invalid') {
          eventBus.emit('handleError')
        } else {
          this.polling = setTimeout(this.pollStatus, 2000)
        }
      }, error => { eventBus.emit('handleError', error.response.data.error) })
    },

    processCheckout () {
      api.post('checkout/' + this.$store.state.orderReference + '/process/', {}).then(response => {
        this.barcodes = response.data
        this.ticketsAvailable = true
      }, error => { eventBus.emit('handleError', error.response.data.error) })
    }
  }
}
</script>

<i18n locale="en">
{
  "title": "Thank you for your reservation",
  "reservationProcessed": "You will receive an e-mail to confirm it.",
  "loading": "Processing reservation…<br>Please wait."
}
</i18n>

<i18n locale="de">
{
  "title": "Vielen Dank für Ihre Reservierung",
  "reservationProcessed": "Sie erhalten in Kürze eine E-Mail zur Bestätigung.",
  "loading": "Bearbeite Reservierung…<br>Bitte warten."
}
</i18n>
